import React from 'react';
import { ClassAssembly8F2026 } from '../views';

const ClassAssemblyPage = () => {
    return <ClassAssembly8F2026/>;
  };
  
  export default ClassAssemblyPage;